import { render, staticRenderFns } from "./indexSix.vue?vue&type=template&id=05400d2a&scoped=true"
import script from "./indexSix.vue?vue&type=script&lang=js"
export * from "./indexSix.vue?vue&type=script&lang=js"
import style0 from "./indexSix.vue?vue&type=style&index=0&id=05400d2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05400d2a",
  null
  
)

export default component.exports